import mutations from './mutations';
import getters from './getters';

export default {
    namespaced: true,
    state() {
        return {
            steps: '0',
            step: '0',
        }
    },
    mutations,
    getters
}